import { FC, useContext, useEffect } from "react";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";

import HubInputField from "../../components/inputType";
import FooterText from "../../components/footerText";
import AuthSubHeader from "../../components/authSubHeader";

import useFetch from "../../hooks/useFetch";
import { ToastContext } from "../../context/toastContext";

import { AddUserSchema } from "../../validation/addUser";
import { AddNewUserApiResponseType, AddNewUserProps } from "./types";
import { APIEndpoints } from "../../types/apiTypes";
import { ToastTypes } from "src/types";


const AddNewUser: FC = (): JSX.Element => {
  const { showToast } = useContext(ToastContext);

  const { control, handleSubmit, reset, setError } = useForm<AddNewUserProps>({
    mode: 'onChange',
    resolver: yupResolver(AddUserSchema)
  });





  const { loading, data, mutate } = useFetch<AddNewUserApiResponseType>(APIEndpoints.ADD_USER);

  useEffect(() => {
    if (data && data.status) {
      if (data.status.code === 500) {
        const errorMessage = data.status.message.includes("unq_user_email_address") ? "Email already exists" : data.status.message.replace(/!/g, "");
        setError("email", { message: errorMessage })
        // showToast([errorMessage], ToastTypes.ERROR);
      } else if (data.status.code === 422) {
        const errorMessage = data.status.message.includes("unq_user_email_address") ? "Email already exists" : data.status.message.replace(/!/g, "");
        setError("email", { message: errorMessage })
      }else{
        reset();
        showToast([data.status.message], ToastTypes.SUCCESS);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);

  const submitNewUser = async (values: AddNewUserProps) => {
    mutate({ user: values });
  };




  return (
      <div className="overflow-y-auto overflow-x-hidden d-flex flex-column flex-fill">
          <div className="bg-mist py-2">
              <div className="container-fluid">
                  <AuthSubHeader/>
              </div>
          </div>
          <div className="container-fluid pt-2 d-flex flex-column flex-fill">
              <div className="mt-4">
                  <h2 className="m-0 page-heading">Add User</h2>
                  <p>Input information in the form below to add a new user to this account. A welcome email will be
                      sent to the email address provided below.
                  </p>
                  <div className="card">
                      <div className="card-body">
                          <form onSubmit={handleSubmit(submitNewUser)}>
                              <div className="row">
                                  <div className="col-12 mb-2">
                                      <Controller
                                          name="firstname"
                                          control={control}
                                          defaultValue=""
                                          render={({field, fieldState: {error}}) => (
                                              <HubInputField
                                                  inputId="firstname"
                                                  isRowBased={true}
                                                  isRequired={true}
                                                  field={field}
                                                  inputLabel="First Name"
                                                  inputPlaceholder="First Name"
                                                  error={error}
                                              />
                                          )}
                                      />
                                  </div>
                                  <div className="col-12 mb-2">
                                      <Controller
                                          name="middlename"
                                          control={control}
                                          defaultValue=""
                                          render={({field, fieldState: {error}}) => (
                                              <HubInputField
                                                  inputId="middlename"
                                                  isRowBased={true}
                                                  isRequired={false}
                                                  field={field}
                                                  inputLabel="Middle Name"
                                                  inputPlaceholder="Middle Name"
                                                  error={error}
                                              />
                                          )}
                                      />
                                  </div>
                                  <div className="col-12 mb-2">
                                      <Controller
                                          name="lastname"
                                          control={control}
                                          defaultValue=""
                                          render={({field, fieldState: {error}}) => (
                                              <HubInputField
                                                  inputId="lastname"
                                                  isRowBased={true}
                                                  isRequired={true}
                                                  field={field}
                                                  inputLabel="Last Name"
                                                  inputPlaceholder="Last Name"
                                                  error={error}
                                              />
                                          )}
                                      />
                                  </div>
                                  <div className="col-12 mb-2">
                                      <Controller
                                          name="email"
                                          control={control}
                                          defaultValue=""
                                          render={({field, fieldState: {error}}) => (
                                              <HubInputField
                                                  inputId="email"
                                                  inputType="email"
                                                  isRowBased={true}
                                                  isRequired={true}
                                                  field={field}
                                                  inputLabel="Email"
                                                  inputPlaceholder="Email Address"
                                                  error={error}
                                              />
                                          )}
                                      />
                                  </div>
                              </div>
                              <button disabled={loading} type="submit" className="btn btn-primary">
                                  {loading ? (
                                      <div className="spinner-border text-light col-3" role="status">
                                          <span className="sr-only"></span>
                                      </div>
                                  ) : null}
                                  Add User
                              </button>
                          </form>
                      </div>
                  </div>
              </div>
          </div>
          <FooterText footerType="black"/>
      </div>
  );
};

export default AddNewUser;
